import { render, staticRenderFns } from "./determineRes.vue?vue&type=template&id=2472ecc2&"
import script from "./determineRes.vue?vue&type=script&lang=js&"
export * from "./determineRes.vue?vue&type=script&lang=js&"
import style0 from "./determineRes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2472ecc2')) {
      api.createRecord('2472ecc2', component.options)
    } else {
      api.reload('2472ecc2', component.options)
    }
    module.hot.accept("./determineRes.vue?vue&type=template&id=2472ecc2&", function () {
      api.rerender('2472ecc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/afterSale/determineRes.vue"
export default component.exports